module.exports = __webpack_public_path__ + "assets/img/zhinan.58970f45.png";